import { AuthorizationAction } from "./authorization.action";
import { InitializerAction } from "../initializer/initiliazer.action";

export class AuthorizationState {
  public token: any;
  public pending: boolean;
  public error: boolean;
  public invalidToken: boolean;
  public requestingToken: boolean;
  public changePhoneToken: boolean;
  public userByToken: any;
  public userByTokenError: any;
};

export const initialState: AuthorizationState = {
  token: {type: 'null', value: 'null', data: null},
  pending: false,
  error: false,
  invalidToken: false,
  requestingToken: false,
  changePhoneToken: false,
  userByToken: null,
  userByTokenError: null,
};

export function AuthorizationReducer(state: AuthorizationState = initialState, {type, payload}){

  switch (type) {

    case AuthorizationAction.authorize:
      return {
        ...state,
        ...{
          pending: false,
          error: false,
          invalidToken: false
        }
      };

    case AuthorizationAction.authorizeNewToken:
      return {
        ...state,
        ...{
          pending: true,
          error: null,
          token: {
            type: payload.tokenType,
            value: payload.token
          }
        }
      };

    case AuthorizationAction.authorizeAborted:
      return {
        ...state,
        ...{
          pending: false,
          error: null
        }
      };

    case AuthorizationAction.authorizeSuccess:
      return {
        ...state,
        ...{
          pending:
          false,
          error: null
        }
      };

    case AuthorizationAction.authorizeDenied:
      return {
        ...state,
        ...{
          pending: false,
          invalidToken: true
        }
      };

    case AuthorizationAction.authorizeError:
      return {
        ...state,
        ...{
          pending: false,
          error: true
        }
      };

    case AuthorizationAction.requestTokenTime:
      return {
        ...state,
        ...{
          requestingToken: true
        }
      };

    case AuthorizationAction.requestTokenTimeError:
      return {
        ...state,
        ...{
          requestingToken: false
        }
      };

    case AuthorizationAction.requestTokenTimeSuccess:
      return {
        ...state,
        ...{
          pending: false
        }
      };

    case InitializerAction.resetUserRelatedData:
      return {
        ...state,
        ...{
          token: initialState.token
        }
      };

    case AuthorizationAction.requestChangePhoneTokenSucess:
      return {
        ...state,
        ...{
          changePhoneTokenSuccess: payload
        }
      };

    case AuthorizationAction.requestChangePhoneTokenError:
      return {
        ...state,
        ...{
          changePhoneTokenError: payload
        }
      };

    case AuthorizationAction.requestUserByTokenSucess:
      return {
        ...state,
        ...{
          userByToken: payload
        }
      };
    case AuthorizationAction.requestUserByTokenError:
      return {
        ...state,
        ...{
          userByTokenError: payload
        }
      };

    default:
      return state;
  }
};
